export default __webpack_public_path__ + "static/media/about.ebfe5e01.png";